export const ZSSL_GET_BUSINESS_LIST_test = new Promise(resolve => {
  const data = {
    Status: 1,
    Data: {
      GYQK: [],
      SQXX: []
    }
  };
  let GYQKitem = {
    ZL: "ZL",
    DJBH: "DJBH",
    SQRMC: "SQRMC",
    QZH: "QZH",
    YJXXDZ: "YJXXDZ",
    ZT: "3",
    LXDH: "123",
    PROVINCE: "广东省",
    CITY: "广东市",
    COUNTY: "天河区"
  };
  let SQXXitem = {
    ZL: "ZL",
    DJBH: "DJBH",
    SQRMC: "SQRMC",
    QZH: "QZH",
    YJXXDZ: "YJXXDZ",
    ZT: "3",
    LXDH: "123",
    PROVINCE: "广东省",
    CITY: "广东市",
    COUNTY: "天河区",
    GYR: [
      {
        SQRMC: "SQRMC",
        ZJHM: "ZJHM",
        QZH: "QZH",
        ZL: "ZL",
        GYFS: "GYFS",
        DH: "DH",
        DJBH: "DJBH"
      }
    ]
  };
  for (let i = 0; i < 3; i++) {
    data.Data.GYQK.push(GYQKitem);
  }
  for (let j = 0; j < 3; j++) {
    data.Data.SQXX.push(SQXXitem);
  }
  resolve(data);
});

export const SUM_SEND_TIME_test = new Promise(resolve => {
  const data = {
    Status: 1,
    Data: "2024-12-02"
  };
  resolve(data);
});

export const PRE_APPLY_LIST_test = new Promise(resolve => {
  let result = {
    DJBH: "DJBH",
    SQR: "SQR",
    ZL: "ZL",
    YWMS: "YWMS"
  };
  const data = {
    Status: 1,
    Data: []
  };
  let results = [];
  for (let i = 0; i < 5; i++) {
    let obj = JSON.parse(JSON.stringify(result));
    results.push(obj);
  }
  data.Data = results;
  resolve(data);
});

export const APPLY_COMMISSION_test = new Promise(resolve => {
  let result = {
    Q_ID: "Q_ID",
    SQR: "SQR",
    ZL: "ZL",
    YWMS: "YWMS",
    QUESTIONTITLE: '申请登记事项是否为申请人的真实意思表示？',
    TEXT: ''
  };
  const data = {
    Status: 1,
    Data: []
  };
  let results = [];
  for (let i = 0; i < 5; i++) {

    let obj = JSON.parse(JSON.stringify(result));
    obj.Q_ID += i
    results.push(obj);
  }
  data.Data = results;
  resolve(data);
});

export const LOAD_SIGN_LIST_test = new Promise(resolve => {
  let result = {
    ZT: "未签名",
    FILENAME: "预告申请",
  };
  const data = {
    Status: 1,
    Data: []
  };
  let results = [];
  for (let i = 0; i < 5; i++) {

    let obj = JSON.parse(JSON.stringify(result));
    obj.Q_ID += i
    results.push(obj);
  }
  data.Data = results;
  resolve(data);
});

export const PRE_VIEW_FILE_test = new Promise(resolve => {
  debugger
  fetch('./static/test/1.pdf').then(response => response.arrayBuffer()).then(data => {
    const Data = {
      Status: 1,
      Data: data
    };
    resolve(data);
  })
});

export const PRE_APPLY_DLRLIST_test = new Promise(resolve => {
  let result = {
    ID: "DJBH",
    YWBLSX: "YWBLSX",
    WTKSRQ: "WTKSRQ",
    WTJSRQ: "WTJSRQ",
    SIGNZT: "0"
  };
  const data = {
    Status: 1,
    Data: []
  };
  let results = [];
  for (let i = 0; i < 5; i++) {
    let obj = JSON.parse(JSON.stringify(result));
    results.push(obj);
  }
  data.Data = results;
  resolve(data);
});

export const LOAD_FACE_DLRLIST_test = new Promise(resolve => {
  let result = {
    FILENAME: "委托书",
    ZT: "未确认"
  };
  const data = {
    Status: 1,
    Data: []
  };
  let results = [];
  for (let i = 0; i < 5; i++) {
    let obj = JSON.parse(JSON.stringify(result));
    results.push(obj);
  }
  data.Data = results;
  resolve(data);
});


// WEBPACK FOOTER //
// ./src/constants/test.js